import { PageJournalFragmentFragment } from '@fm-nx/contentful-types';
import { SlideshowJournalProps } from '@fm-nx/ui';
import { useState } from 'react';

// Generate random index outside of render to satisfy React Compiler purity rules
const getRandomInt = (min: number, max: number) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

// get random category page for slideshow
const useSlideshowProps = ({
    page,
    headerText,
}: {
    page: PageJournalFragmentFragment;
    headerText?: string;
}): { slideshowProps: SlideshowJournalProps } => {
    // Use useState with lazy initializer to avoid calling Math.random during render
    const [slideshowProps] = useState(() => {
        const props: Partial<SlideshowJournalProps> = { excludeId: page.sys.id };
        if (headerText) {
            props.headerText = headerText;
        }
        if (page.technologiesCollection?.items?.length) {
            const technologyId = getRandomInt(0, page.technologiesCollection.items.length - 1);
            return { ...props, technologyId: page.technologiesCollection.items[technologyId]?.sys.id };
        }
        if (page.servicesCollection?.items?.length) {
            return { ...props, serviceId: page.servicesCollection.items[0]?.sys.id };
        }
        if (page.solutionsCollection?.items?.length) {
            return { ...props, solutionId: page.solutionsCollection.items[0]?.sys.id };
        }
        if (page.companyTopicsCollection?.items?.length) {
            return { ...props, companyTopicId: page.companyTopicsCollection.items[0]?.sys.id };
        }
        return props;
    });

    return { slideshowProps };
};

export default useSlideshowProps;
